export default __webpack_public_path__ + "static/11-19590dabd38eb74832bcce72a30e804e.png";